export const noSpaceRegex = /[\n\r\t\s]+/g